import { render, staticRenderFns } from "./semanticAdd.vue?vue&type=template&id=3331f0d0&scoped=true&"
import script from "./semanticAdd.vue?vue&type=script&lang=js&"
export * from "./semanticAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3331f0d0",
  null
  
)

export default component.exports